export default "__VITE_ASSET__BXPi4wgP__"